// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sidebar-module__sidebarContainer--Pymcf {
  flex: 0 0 auto; /* Don't grow or shrink. */
  background-color: var(--sidebar-color);
  width: var(--sidebar-width);
  padding: var(--sidebar-padding);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.Sidebar-module__sidebarPrimaryButtonsContainer--beY6C {
  display: flex;
  flex-direction: column;
  gap: var(--sidebar-gap);
}

img.Sidebar-module__logo--grpJZ {
  padding: 0.5rem;
  display: flex;
  width: 3rem;
}

.Sidebar-module__divider--pFYs4 {
  width: 100%;
  border: 0.0625rem solid var(--sidebar-button-active-border-color);
}

button.Sidebar-module__sidebarButton--bssea {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: var(--sidebar-button-border-radius);
  width: var(--sidebar-button-size);
  height: var(--sidebar-button-size);
}
button.Sidebar-module__sidebarButton--bssea:not(:disabled):hover {
  background: var(--sidebar-button-hover-background-color);
  border: var(--button-border-width) solid var(--sidebar-button-hover-border-color);
}
button.Sidebar-module__sidebarButton--bssea:focus-visible {
  background: var(--sidebar-button-active-background-color);
  border: var(--button-border-width) solid var(--sidebar-button-focus-border-color);
}
button.Sidebar-module__sidebarButton--bssea.Sidebar-module__sidebarButtonActive--p_MIy {
  background: var(--sidebar-button-active-background-color);
  border: var(--button-border-width) solid var(--sidebar-button-active-border-color);
}

.Sidebar-module__sidebarIcon--W6T73 {
  color: var(--sidebar-button-icon-color);
  width: 1rem;
  height: 1rem;
}

button.Sidebar-module__sidebarButton--bssea:disabled .Sidebar-module__sidebarIcon--W6T73 {
  color: var(--sidebar-button-disabled-icon-color);
}`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/Sidebar.module.scss"],"names":[],"mappings":"AAAA;EACC,cAAA,EAAA,0BAAA;EAEA,sCAAA;EACA,2BAAA;EACA,+BAAA;EAEA,aAAA;EACA,sBAAA;EACA,8BAAA;AADD;;AAIA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;AADD;;AAIA;EACC,eAAA;EACA,aAAA;EACA,WAAA;AADD;;AAIA;EACC,WAAA;EACA,iEAAA;AADD;;AAIA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,6BAAA;EACA,kDAAA;EAEA,iCAAA;EACA,kCAAA;AAHD;AAKC;EACC,wDAAA;EACA,iFAAA;AAHF;AAOC;EACC,yDAAA;EACA,iFAAA;AALF;AASC;EACC,yDAAA;EACA,kFAAA;AAPF;;AAYA;EACC,uCAAA;EACA,WAAA;EACA,YAAA;AATD;;AAWA;EACC,gDAAA;AARD","sourcesContent":[".sidebarContainer {\n\tflex: 0 0 auto; /* Don't grow or shrink. */\n\n\tbackground-color: var(--sidebar-color);\n\twidth: var(--sidebar-width);\n\tpadding: var(--sidebar-padding);\n\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n}\n\n.sidebarPrimaryButtonsContainer {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: var(--sidebar-gap);\n}\n\nimg.logo {\n\tpadding: 0.5rem;\n\tdisplay: flex;\n\twidth: 3rem;\n}\n\n.divider {\n\twidth: 100%;\n\tborder: 0.0625rem solid var(--sidebar-button-active-border-color);\n}\n\nbutton.sidebarButton {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\tbackground-color: transparent;\n\tborder-radius: var(--sidebar-button-border-radius);\n\n\twidth: var(--sidebar-button-size);\n\theight: var(--sidebar-button-size);\n\n\t&:not(:disabled):hover {\n\t\tbackground: var(--sidebar-button-hover-background-color);\n\t\tborder: var(--button-border-width) solid\n\t\t\tvar(--sidebar-button-hover-border-color);\n\t}\n\n\t&:focus-visible {\n\t\tbackground: var(--sidebar-button-active-background-color);\n\t\tborder: var(--button-border-width) solid\n\t\t\tvar(--sidebar-button-focus-border-color);\n\t}\n\n\t&.sidebarButtonActive {\n\t\tbackground: var(--sidebar-button-active-background-color);\n\t\tborder: var(--button-border-width) solid\n\t\t\tvar(--sidebar-button-active-border-color);\n\t}\n}\n\n.sidebarIcon {\n\tcolor: var(--sidebar-button-icon-color);\n\twidth: 1rem;\n\theight: 1rem;\n}\nbutton.sidebarButton:disabled .sidebarIcon {\n\tcolor: var(--sidebar-button-disabled-icon-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebarContainer": `Sidebar-module__sidebarContainer--Pymcf`,
	"sidebarPrimaryButtonsContainer": `Sidebar-module__sidebarPrimaryButtonsContainer--beY6C`,
	"logo": `Sidebar-module__logo--grpJZ`,
	"divider": `Sidebar-module__divider--pFYs4`,
	"sidebarButton": `Sidebar-module__sidebarButton--bssea`,
	"sidebarButtonActive": `Sidebar-module__sidebarButtonActive--p_MIy`,
	"sidebarIcon": `Sidebar-module__sidebarIcon--W6T73`
};
export default ___CSS_LOADER_EXPORT___;
